import axios from 'axios';
import Vue from 'vue'

export default {
  
    getPaymentOffre(page, pageSize) {
        return axios.get('/api/payment/all',{ params: {page: page, pageSize: pageSize } })
        .then(response => {

            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addPaymentOffre(OffreId) {
        const url = '/api/payment/process/' + OffreId;

        return axios.get(url)
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {
                Vue.prototype.$snotify.error(error);
            });
    },
}